import { useCallback, useEffect, useState } from 'react'

const normalizeValue = value => `${value || ''}`.trim()

export const useDebouncedMatchValidation = ({
	primaryValue,
	secondaryValue,
	requiredMessage,
	mismatchMessage,
	debounceMs = 600
}) => {
	const [error, setError] = useState('')

	const validateMatch = useCallback(({ required = false } = {}) => {
		const normalizedPrimaryValue = normalizeValue(primaryValue)
		const normalizedSecondaryValue = normalizeValue(secondaryValue)

		if (!normalizedSecondaryValue) {
			if (required) {
				setError(requiredMessage)
				return false
			}

			setError('')
			return true
		}

		if (normalizedPrimaryValue !== normalizedSecondaryValue) {
			setError(mismatchMessage)
			return false
		}

		setError('')
		return true
	}, [mismatchMessage, primaryValue, requiredMessage, secondaryValue])

	const clearError = useCallback(() => {
		setError(prevError => (prevError ? '' : prevError))
	}, [])

	useEffect(() => {
		if (!normalizeValue(secondaryValue)) {
			setError('')
			return undefined
		}

		const timeoutId = setTimeout(() => {
			validateMatch()
		}, debounceMs)

		return () => clearTimeout(timeoutId)
	}, [debounceMs, secondaryValue, validateMatch])

	return {
		error,
		validateMatch,
		clearError
	}
}